__turbopack_context__.v({
  "root": "SocialMediaBar-module__GnfbJq__root",
});
